import { render } from "./Users.vue?vue&type=template&id=6b54a564&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=6b54a564&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b54a564"]])

export default __exports__